// extracted by mini-css-extract-plugin
module.exports = {"oversiktListPanel":"OversiktListPanel_oversiktListPanel__otj_x","merOmLenke":"OversiktListPanel_merOmLenke__HN8rP"};